module.exports = __webpack_public_path__ + "static/media/subscribe.fc85478a.jpg";